  $(function ($) {
  var $accordion = $('.ce-accordion');
  var accordionStatus = $accordion.data('accordion-status');
  var $accordionContainer = $accordion.find('.accordion');

  // Collapse behavior
  $accordion.on('hide.bs.collapse', function (event) {
  var headingSelector = '#' + $(event.target).attr('aria-labelledby');
  $(headingSelector).removeClass('active');
  $(headingSelector).find('h5').removeClass('active');
});

  $accordion.on('show.bs.collapse', function (event) {
  var headingSelector = '#' + $(event.target).attr('aria-labelledby');
  $(headingSelector).addClass('active');
  $(headingSelector).find('h5').addClass('active');
});

  // Handle initial state based on accordionStatus
  if (accordionStatus === 'allClosed') {
  $accordionContainer.find('.collapse').removeClass('show');
  $accordionContainer.find('.card-header').removeClass('active');
  $accordionContainer.find('.card-header').attr('aria-expanded', 'false');
} else if (accordionStatus === 'allOpen') {
  $accordionContainer.find('.collapse').addClass('show');
  $accordionContainer.find('.card-header').addClass('active');
  $accordionContainer.find('.card-header').attr('aria-expanded', 'true');
} else if (accordionStatus === 'firstOpen') {
  // Close all panels first
  $accordionContainer.find('.collapse').removeClass('show');
  $accordionContainer.find('.card-header').removeClass('active');
  $accordionContainer.find('.card-header').attr('aria-expanded', 'false');

  // Then open just the first one
  $accordionContainer.find('.card:first .collapse').addClass('show');
  $accordionContainer.find('.card:first .card-header').addClass('active');
  $accordionContainer.find('.card:first .card-header').attr('aria-expanded', 'true');
}
});
